
import createLogger from 'debug'
import useSWR from 'swr'
import { useApi } from '../lib/useApi'
import { swrLoadOnce } from '../lib/swrConfig'

import { User } from './profile.types'
import { ProfileContextProvider } from 'lib-core'
import { useSelector } from 'react-redux'
import { ReactFC } from 'types'
import React from 'react'
import { useInstanceValue } from 'navigation/instance.selectors'
// to enable localStorage.debug = 'info:*'
const info = createLogger('info:ui')

export const useUserProfile = () => {
    const api = useApi()
    const result = useSWR<User>("/profile", (path) => api.makeRequest({
        path,
        method: "GET"
    }), swrLoadOnce)
    const { data } = result

    if (data) {
        info("profile: %o", data)
    }

    return result
}

export const selectProfileData = state => state?.session?.value
const selectProfileError = state => state?.session?.error

export const ReduxProfileContextProvider: ReactFC = ({ children }) => {
    const profile = useSelector(selectProfileData)
    const error = useSelector(selectProfileError)
    const instance = useInstanceValue()
    return (
        <ProfileContextProvider profile={profile} instance={instance} error={error} >{children}</ProfileContextProvider>
    )
}                            
